import styled from 'styled-components';

const Message = styled.div`
  padding: 0.844rem 1.125rem;
  color: #ffffff;
  border-radius: 0.125rem;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  background-color: ${({ backgroundColor = 'currentColor' }) =>
    backgroundColor};
`;

export default Message;
